import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

const DeleteHandle = {
  name:   'deleteHandle',
  props:  {},
  events: {},
  css:    ['otherTarget'],
  render(moveable, React) {
    const translateX =  (moveable.props.cropHandle) ? 82 : 41;
    const rect       = moveable.getRect();
    const { pos2 }   = moveable.state;
    return React.createElement('div', {
      class: 'extended-button delete-button d-flex align-items-center justify-content-center mt-5"',
      style: {
        position:        'absolute',
        left:            '0px',
        top:             '0px',
        transform:       `translate(${pos2[0]}px, ${pos2[1]}px) rotate(${rect.rotation}deg) translate(10px, ${translateX}px)`,
        transformOrigin: '0 0',
      },
      key:     'delete-handle',
      onClick: (event) => {
        event.stopPropagation();
        EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, {
          request: 'DeleteReq',
          data:    -1,
          message: 'Are you sure you want to delete selected Layer(s)?',
          isVideo: true,
        });
      },
    }, '');
  },
};
export default DeleteHandle;
